<template>
    <div class="">
        <div class=" block appearance-none w-full border border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight mb-2"   @click="update(index)" :class="selection[index]?'bg-green-500 text-white':'bg-white'" v-for="(value, index) in values" :key="`${option.id}.${value.id}`" >

            <svg v-if="selection[index]" class="fill-current h-4 w-4 inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M8.294 16.998c-.435 0-.847-.203-1.111-.553L3.61 11.724a1.392 1.392 0 0 1 .27-1.951 1.392 1.392 0 0 1 1.953.27l2.351 3.104 5.911-9.492a1.396 1.396 0 0 1 1.921-.445c.653.406.854 1.266.446 1.92L9.478 16.34a1.39 1.39 0 0 1-1.12.656c-.022.002-.042.002-.064.002z"/></svg>


            {{ value.label }} {{ (value.price && value.price > 0) ? `$ ${(1*value.price).toFixed(2)}` : '' }}

        </div>
    </div>
</template>

<script>


    export default {
        name: "ItemSelectorCheckbox",
        props: ['value', 'values', 'option'],
        data() {
            let preselect = {};
            this.value.forEach(id => {
                preselect[id] = true;
            })
            return {
                selection: this.values.map(value => {
                    const id = `${this.option.id}.${value.id}`;
                    if (preselect[id]) {
                        return true;
                    } else {
                        return false;
                    }
                }),
            };
        },

        methods: {

            update(index) {

                if (this.option.limit && this.selection[index] === false) {
                    const limit = 1 * this.option.limit;
                    if (!isNaN(limit) && limit > 0 && this.selection.filter(e => e).length === limit) {
                        return;
                    }
                }

                let selection = !this.selection[index];
                this.selection.splice(index, 1, selection);

                this.$emit('input', this.values.map((value, index) => {
                    if (this.selection[index]) {
                        return `${this.option.id}.${value.id}`;
                    } else {
                        return '';
                    }
                }).filter(id => id));
            }
        }

    }
</script>

<style scoped>

</style>
